import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import theme from '../../app/app-theme';

interface TableActionButtonProps {
    readonly onClick: () => void;
    readonly icon: React.ReactNode;
    readonly label: string;
    readonly disabled?: boolean;
}

const TableActionButton: React.FC<TableActionButtonProps> = ({ icon, label, disabled, onClick }) => {

    return (
        <Tooltip title={label} disableInteractive>
            <IconButton onClick={onClick} sx={{ color: `${theme.palette.secondary.main}` }} className="table-action-button" disabled={disabled}>{icon}</IconButton>
        </Tooltip>
    );
}

export default TableActionButton;